import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/** Respuesta del endpoint de token Torre de Control (backend hace proxy a opbs.opb.cl) */
export interface TorreControlTokenResponse {
    token: string;
    baseUrl: string;
    [key: string]: unknown;
}

/**
 * Servicio para Torre Control Transporte.
 * El token se pide a nuestro backend (GET /api/v1/torre-control-transporte/token),
 * que a su vez llama a opbs.opb.cl. Así se evita CORS: el navegador no llama
 * directamente a la URL externa.
 * El backend retorna el token según el rol: cliente (clientId real) o admin/operador (clientId=0).
 */
@Injectable({
    providedIn: 'root',
})
export class TorreControlTransporteService {
    private readonly tokenUrl = `${environment.apiUrl}/v1/torre-control-transporte/token`;

    constructor(private readonly http: HttpClient) {}

    /**
     * Obtiene el token para la Torre de Control.
     * El backend determina clientId/nombre según el rol del usuario (JWT).
     */
    getToken(): Observable<TorreControlTokenResponse> {
        return this.http.get<TorreControlTokenResponse>(this.tokenUrl);
    }
}
